'use strict'
import InputError from './lib/InputError';
import Failed from './lib/Failed';

Date.prototype.getFullMinutes = function () {
    if (this.getMinutes() < 10) {
        return '0' + this.getMinutes();
    }
    return this.getMinutes();
 };

class Schedule {
    
    constructor(options) {
        var self=this;
        grecaptcha.enterprise.ready(async () => {
            self.recaptcha_token = await grecaptcha.enterprise.execute(options.access_key, {action: 'LOGIN'});
        });

        let input_datetime = document.querySelector('input[name="date_and_time"]');
        let branch_office = document.querySelector('select[name="branch_office"]');

        let format = (new Intl.DateTimeFormat()).formatToParts().map(function(e) {
            switch(e.type) {
              case 'month':
                return 'm'; break;
              case 'day':
                return 'd'; break;
              case 'year':
                return 'Y'; break;
              default: 
                return e.value;
            };
        }).join('');
        document.querySelector('input[name="date_time_format"]').value = format;

        
        input_datetime.addEventListener('input', function (e){

            let from = branch_office.options[branch_office.selectedIndex].dataset.hoursFrom;
            let to = branch_office.options[branch_office.selectedIndex].dataset.hoursTo;

            let from_arr = from.split(':');
            let to_arr = to.split(':');
            let h = {
                from: {
                    time: parseInt(`${from_arr[0]}${from_arr[1]}`)
                },
                to: {
                    time: parseInt(`${to_arr[0]}${to_arr[1]}`)
                },
            }
            
            var dt = new Date(this.value);
            let day = dt.getUTCDay();
            if([6,0].includes(day)){
                e.target.setCustomValidity('Fin de semana no permitido');
                InputError.show({
                    date_and_time:['Fin de semana no permitido']
                });
            } else {
                e.target.setCustomValidity('');
                InputError.reset();

                let time = parseInt(`${dt.getHours()}${dt.getFullMinutes()}`);
                if(time < h.from.time || time > h.to.time){
                    e.target.setCustomValidity(`El horario permitido es a partir de las ${from} hasta las ${to} Hrs`);
                    InputError.show({
                        date_and_time:[`El horario permitido es a partir de las ${from} hasta las ${to} Hrs`]
                    });
                }
            }
        });

        $('select[name="branch_office"]').on('change', (e) => {
            e.preventDefault();
            input_datetime.dispatchEvent(new Event('input', {bubbles:true}));
        });
    }

    init () {
        var self=this;
        $('form[name="schedule"]').on('submit', (e) => {            
            $(e.currentTarget).find('button[type="submit"]').loading();
            InputError.reset();
            
            let serialize_data = $('form[name="schedule"]').serializeArray().map((it) => {
                if(it.name === 'date_and_time'){
                    let d = new Date(it.value);
                    return `${it.name}=${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1).toString().padStart(2, "0")}/${d.getFullYear()} ${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`; 
                }
                if(it.name === 'date_of_birth'){
                    let d = new Date(it.value);
                    return `${it.name}=${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1).toString().padStart(2, "0")}/${d.getFullYear()}`; 
                }
                return `${it.name}=${encodeURIComponent(it.value)}`;
            }).join('&');
            serialize_data=serialize_data+'&g-recaptcha-response='+self.recaptcha_token;

            $.ajax({
                url: $(e.currentTarget).attr('action'),
                type : "POST",
                dataType : 'json',
                data : serialize_data,
                success : (data) => {
                    $(e.currentTarget).find('button[type="submit"]').finish();
                    if (data.status === 1){
                        return Failed.success({
                            icon:{
                                type:'icon--success',
                                src:'ic-success-result.svg'
                            },
                            'title': 'Te has agendado con éxito.',
                            'description':'Un representante de Servicio al Cliente te contactará. ¡Gracias!',
                        });
                    }
                    if (data.status === 2){
                        return Failed.show(data.message);
                    }
                    InputError.validate();
                    if (data.error){
                        InputError.show(data.error);
                    }
                },
                error: function(xhr, resp, text) {
                    $(e.currentTarget).find('button[type="submit"]').finish();
                    console.log(xhr, resp, text);
                }
            });
            return false;
        });
    }
}

export default Schedule;